/* global axios */
// FLOW-03a (SPEC S2, S7; PLAN P5, P18; Tasks 7.2 e 7.3) — os gatilhos de agenda e de webhook dos flows da
// conta (`PowerflowGatilhosController`): a lista (a linha de cada flow em Flows, o detalhe do gatilho e a
// URL de teste do editor), o liga e pausa, a troca do token do webhook, as últimas chamadas e a prévia da
// agenda que o editor está escrevendo. Usa o axios global.
//
// Cada gatilho vem como `{id, flow_name, gatilho_id, tipo, config, ligado, ligado_em, publicado,
// contagens_do_dia}`, mais, no webhook, `url_de_teste` (sempre) e `url` (só publicado) e, na agenda,
// `estado_da_agenda` (`{proxima_em, ultimo_desfecho, puladas_hoje, frase, ...}`, nulo com o PowerTools fora).
// ACESSO-01 (L11b): com a chave ACESSO_GRANULAR ligada e sem o `powerflow:run`, as duas URLs vêm sem o
// token, com `url_mascarada: true`.
//
// As recusas chegam no `response.data` do erro do axios: `{erro: {codigo, mensagem, como_resolver,
// campo?}}` (404 do gatilho que não é da conta; 422 `gatilho_so_do_rascunho`, `ligado_obrigatorio`,
// `gatilho_sem_token`, `regra_invalida`); 403 para quem não vê a aba; 503/504 do PowerTools na prévia.
const BASE = accountId => `/api/v1/accounts/${accountId}/powerflow/gatilhos`;
const DO = (accountId, id) => `${BASE(accountId)}/${encodeURIComponent(id)}`;

const body = r => r.data;

// O código da recusa de leigo, ou nulo.
export const codigoDaRecusa = erro =>
  erro?.response?.data?.erro?.codigo || null;

// O gatilho que só o rascunho tem não liga antes de publicar (o 422 do `update`).
export const SO_DO_RASCUNHO = 'gatilho_so_do_rascunho';

export default {
  // Os gatilhos da conta, ou de um flow com `flowName`, em ordem de flow e de id.
  index(accountId, { flowName } = {}) {
    const params = flowName ? { flow_name: flowName } : {};
    return axios
      .get(BASE(accountId), { params })
      .then(({ data }) => (Array.isArray(data?.gatilhos) ? data.gatilhos : []));
  },

  // Liga ou pausa. Devolve o gatilho com `agendas_sincronizadas` (false quando o PowerTools não ouviu
  // agora; a reconciliação de 5 min corrige).
  alternar(accountId, id, ligado) {
    return axios.patch(DO(accountId, id), { ligado }).then(body);
  },

  // O token que vazou: o velho para na hora, e o gatilho volta com a `url` nova.
  trocarToken(accountId, id) {
    return axios.post(`${DO(accountId, id)}/trocar_token`).then(body);
  },

  // As últimas 50, da mais nova para a mais antiga: `[{at, desfecho, status, execucao_id, teste?, sessao_id?}]`.
  chamadas(accountId, id) {
    return axios
      .get(`${DO(accountId, id)}/chamadas`)
      .then(({ data }) => (Array.isArray(data?.chamadas) ? data.chamadas : []));
  },

  // `{proximas: [ISO], frase}` da regra `{a_cada_s}` ou `{cron, fuso}`, sem gravar nada.
  previa(accountId, regra, n = 3) {
    return axios.post(`${BASE(accountId)}/previa`, { regra, n }).then(body);
  },
};
